"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/input/style");
var _input = _interopRequireDefault(require("antd/lib/input"));
var _react = _interopRequireWildcard(require("react"));
var _login = require("../../../../../consts/login");
var _accountNetSdk = require("account-net-sdk");
require("./style.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _cryptoJs = _interopRequireDefault(require("crypto-js"));
var _valid = require("../../../../../consts/valid");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Key = 'bmsdFXCczSlLiucSP443CV4QacWi4r7O';
var Password = function Password(props) {
  var validCbData = props.validCbData,
    setIsRealName = props.setIsRealName,
    setRefreshCaptcha = props.setRefreshCaptcha,
    curItem = props.curItem,
    onError = props.onError,
    _props$useType = props.useType,
    useType = _props$useType === void 0 ? _login.DEFAULT_USE_TYPE : _props$useType;
  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    errTip = _useState2[0],
    setErrTip = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    _useState4 = _slicedToArray(_useState3, 2),
    account = _useState4[0],
    setAccount = _useState4[1];
  var _useState5 = (0, _react.useState)(''),
    _useState6 = _slicedToArray(_useState5, 2),
    password = _useState6[0],
    setPassword = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    loading = _useState8[0],
    setLoading = _useState8[1];
  /**
   * 登录
   * @param captcha
   * @param cookies
   * @param balanceCode
   * @param publicIp
   */
  var handleLogin = function handleLogin() {
    var captcha = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var cookies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var balanceCode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var publicIp = arguments.length > 3 ? arguments[3] : undefined;
    var params = {
      account: account.trim(),
      password: password.trim(),
      captcha: captcha,
      bid: _login.LOGIN_USE_TYPE[useType].bId,
      cookies: cookies,
      balanceCode: balanceCode,
      isHaiWai: useType !== _login.DEFAULT_USE_TYPE
    };
    if (publicIp) {
      params.nid = _cryptoJs.default.AES.encrypt(publicIp, _cryptoJs.default.enc.Utf8.parse(Key), {
        iv: _cryptoJs.default.enc.Utf8.parse('6543210987654321'),
        mode: _cryptoJs.default.mode.CBC,
        padding: _cryptoJs.default.pad.Pkcs7
      }).toString();
    }
    (0, _accountNetSdk.AccountLogin)(params, useType).then(function (res) {
      var data = res.data;
      setLoading(false);
      if (!res.success) {
        if (data === _login.LOGIN_STATUS.needCaptcha) {
          // 需要验证码
          props.onShow(true);
        }
        // else if (data === LOGIN_STATUS.captchaError) {
        //   // 验证码错误
        //   setErrTip('验证码错误');
        // }
        else if (data === _login.LOGIN_STATUS.realNameError) {
          // 需要实名
          setIsRealName(true);
          setRefreshCaptcha && setRefreshCaptcha(Math.random());
        } else {
          setErrTip(res.message);
        }
        onError && onError(res);
        return;
      }
      // 登录成功
      props.onOk && props.onOk(_objectSpread(_objectSpread({}, data), {}, {
        type: 'pw'
      }));
    }, function (error) {
      setErrTip(error.message);
      setLoading(false);
    });
  };
  // 提交
  var handleSubmit = function handleSubmit() {
    var accountRules = _login.LOGIN_USE_TYPE[useType].accountRules;
    // 校验账号
    var _handleValid = (0, _valid.handleValid)(account.trim(), accountRules),
      accountMsg = _handleValid.msg,
      accountValid = _handleValid.valid;
    if (!accountValid) {
      setErrTip(accountMsg);
      return;
    }
    // 校验密码
    var _handleValid2 = (0, _valid.handleValid)(password.trim(), _valid.PW_RULES),
      pwMsg = _handleValid2.msg,
      pwValid = _handleValid2.valid;
    if (!pwValid) {
      setErrTip(pwMsg);
      return;
    }
    setErrTip('');
    setLoading(true);
    handleLogin();
  };
  /**
   * 监听验证码返回对象
   */
  (0, _react.useEffect)(function () {
    if ((validCbData === null || validCbData === void 0 ? void 0 : validCbData.captcha) && curItem === 'pw') {
      var captcha = validCbData.captcha,
        cookies = validCbData.cookies,
        balanceCode = validCbData.balanceCode,
        publicIp = validCbData.publicIp;
      handleLogin(captcha, cookies, balanceCode, publicIp);
    }
  }, [validCbData]);
  (0, _react.useEffect)(function () {
    if (useType !== _login.DEFAULT_USE_TYPE) {
      setErrTip("2014\u5E742\u670828\u65E5\u524D\u6CE8\u518C\u7528\u6237\u8BF7\u5728\u5E10\u53F7\u524D\u6DFB\u52A0\u4E0B\u5212\u7EBF'_'");
    }
  }, [useType]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_login_pw_wrap"
  }, errTip !== '' && /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_pw_form_error"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "gy_pw_form_error_icon"
  }), /*#__PURE__*/_react.default.createElement("span", {
    id: "text_pw_login",
    className: "error_text"
  }, errTip)), /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_pw_form_item"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)('gy_pw_name_icon', 'gy_pw_form_icon')
  }), /*#__PURE__*/_react.default.createElement(_input.default, {
    className: (0, _classnames.default)('gy_pw_form_name', 'gy_pw_form_input'),
    maxLength: _login.LOGIN_USE_TYPE[useType].maxLength,
    value: account,
    onChange: function onChange(e) {
      return setAccount(e.target.value);
    },
    placeholder: "\u8D26\u53F7",
    id: "input_pw_login_account",
    onPressEnter: handleSubmit
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_pw_form_item"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)('gy_pw_icon', 'gy_pw_form_icon')
  }), /*#__PURE__*/_react.default.createElement(_input.default.Password, {
    visibilityToggle: false,
    className: "gy_pw_form_input",
    maxLength: 16,
    value: password,
    onChange: function onChange(e) {
      return setPassword(e.target.value);
    },
    placeholder: "\u5BC6\u7801",
    id: "input_pw_login_password",
    onPressEnter: handleSubmit
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('gy_pw_form_submit', {
      loginActive: loading
    }),
    id: "input_pw_login_submit",
    onClick: handleSubmit
  })));
};
var _default = Password;
exports.default = _default;